import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-toolbox';
import Card from 'components/Card';
import S from '../styles.scss';

const STATE_CHIPS = {
  auto_applied: 'APPLIED BY SPOTBOT',
  accepted: 'APPLIED',
  edited: 'EDITED',
  rejected: 'DISMISSED',
};

const percent = confidence => (confidence ? `${Math.round(confidence * 100)}%` : '—');

const statusClass = status => (
  status && status.indexOf('Error') === 0 ? S.statusError : S.statusCorrect
);

// M4: SPOTBOT's proposed verification status per PO line item, with its reasoning. Safe
// statuses can arrive already auto-applied (auto_safe autonomy); every Error/Not Enough
// Information row waits for a human Accept, which writes through the normal line-item flow.
const LineItemVerification = ({ proposals, lineItems, onResolve }) => {
  if (proposals.length === 0) return null;
  const itemFor = proposal =>
    lineItems.find(item => item.id === proposal.target.phase_line_item_id) || {};
  return (
    <Card className={S.card}>
      <div className={S.headerContainer}>
        <h4 className={S.title}>SPOTBOT Labor & Product Verification</h4>
      </div>
      <div className={S.checklistContainer}>
        <p>
          SPOTBOT compared each PO line item to the Detail. Accept writes the proposed
          status; Dismiss records that the proposal was wrong.
        </p>
        <table className={S.verificationTable}>
          <thead>
            <tr>
              <th>Item</th><th>Qty</th><th>Current</th><th>Proposed</th>
              <th>Confidence</th><th>Why</th><th />
            </tr>
          </thead>
          <tbody>
            {proposals.map((proposal) => {
              const item = itemFor(proposal);
              return (
                <tr key={proposal.id}>
                  <td>{item.description}</td>
                  <td>{item.quantity}</td>
                  <td>{item.status}</td>
                  <td className={statusClass(proposal.proposed_value)}>
                    {proposal.proposed_value}
                  </td>
                  <td>{percent(proposal.confidence)}</td>
                  <td className={S.suggestionReason}>{proposal.rationale}</td>
                  <td className={S.suggestionActions}>
                    {STATE_CHIPS[proposal.state] ? (
                      <span className={S.appliedChip}>{STATE_CHIPS[proposal.state]}</span>
                    ) : (
                      <span>
                        <Button
                          label="Accept" flat inverse ripple className={S.saveButton}
                          onClick={() => onResolve(proposal, 'accepted')}
                        />
                        <Button
                          label="Dismiss" flat ripple
                          onClick={() => onResolve(proposal, 'rejected')}
                        />
                      </span>
                    )}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Card>
  );
};

LineItemVerification.propTypes = {
  proposals: PropTypes.arrayOf(PropTypes.object).isRequired,
  lineItems: PropTypes.arrayOf(PropTypes.object).isRequired,
  onResolve: PropTypes.func.isRequired,
};

export default LineItemVerification;



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/tabs/phaseContractVerificationChecklist/components/lineItemVerification.jsx